// extracted by mini-css-extract-plugin
export default {"show_play_btn":"style_show_play_btn__j4yD3","hide_play_btn":"style_hide_play_btn__GD3nu","top_sec":"style_top_sec__bEU3Y"};